import { render, staticRenderFns } from "./workorder-charts-ring.vue?vue&type=template&id=6c5ffe1f&scoped=true&"
import script from "./workorder-charts-ring.vue?vue&type=script&lang=js&"
export * from "./workorder-charts-ring.vue?vue&type=script&lang=js&"
import style0 from "./workorder-charts-ring.vue?vue&type=style&index=0&id=6c5ffe1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ffe1f",
  null
  
)

export default component.exports